export const COMPONENTS_MAP = new Map();
export const WHITELIST_COMPONENTS_INPUTS = new Map();

/** Decorator to ease mapping and getting dynamic component by id */
export function DynamicComponentRegister(key: string, whiteListInputs = false) {
  return (constr: unknown) => {
    if (COMPONENTS_MAP.has(key)) {
      throw new Error(`Dynamic component with key ${key} already registered`);
    }

    COMPONENTS_MAP.set(key, constr);
    WHITELIST_COMPONENTS_INPUTS.set(key, whiteListInputs);
  };
}
